module.exports = __webpack_public_path__ + "static/media/02-kor.80e3a26c.png";